import { ImageLike } from 'src/modules/renderings/imageLike';
import type { HiDefRendering, JobImage } from 'src/shared/graphql/generated';

/* Initialize files as ImageLike */
const sanitizeRenderings = (renderings: HiDefRendering[]) =>
  renderings?.map((rendering: HiDefRendering) => ({
    ...rendering,
    versions: rendering?.versions.map((version, versionIndex) => ({
      ...version,
      hiDefRenderingFiles: version.hiDefRenderingFiles.map(
        (hiDefRenderingFile, hiDefRenderingFileIndex) => ({
          ...hiDefRenderingFile,
          image: new ImageLike(hiDefRenderingFile.image, {
            labelType: 'rendering',
            collectionNumber: versionIndex + 1,
            collectionIndex: hiDefRenderingFileIndex + 1,
          }),
        }),
      ),
    })),
  }));

const sanitizeImages = (images: JobImage[]) =>
  (images || []).map(
    (img, idx) =>
      new ImageLike(img, {
        labelType: 'original',
        collectionNumber: 1,
        collectionIndex: idx + 1,
      }),
  );

export { sanitizeRenderings, sanitizeImages };
